// extracted by mini-css-extract-plugin
export default {"header":"iFAiSYUif4Tf0HpWDP1F5g=="};